import React, { useState, useEffect } from 'react';

const Portfolio = ({ data }) => {
  const [currentTime, setCurrentTime] = useState(() => {
    return new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  });

  useEffect(() => {
    const updateTimer = () => {
      setCurrentTime(new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }));
    };
    const timer = setInterval(updateTimer, 1000);
    return () => clearInterval(timer);
  }, []);

  if (!data) return null;

  const getBadge = (title, url) => {
    if (title.includes('Tape')) return { label: 'AUDIO APP', type: 'badge-gold' };
    if (title.includes('Geeta')) return { label: 'LIVE APP', type: 'badge-gold' };
    if (title.includes('Vaak')) return { label: 'AI-NATIVE', type: 'badge-cyan' };
    if (url.includes('apple.com')) return { label: 'APP STORE', type: 'badge-blue' };
    if (url.includes('google.com')) return { label: 'PLAY STORE', type: 'badge-green' };
    if (title.includes('Math Guru')) return { label: 'EDUCATION', type: 'badge-purple' };
    if (url.startsWith('http')) return { label: 'LIVE APP', type: 'badge-live' };
    return { label: 'DEMO', type: 'badge-demo' };
  };

  const cleanTitle = (title) => {
    if (title === 'Math Guru Workshop') return 'Math Workshop';
    if (title === 'Math Guru - Play') return 'Math Play';
    if (title.startsWith('Math Guru - ')) return title.replace('Math Guru - ', '');
    return title;
  };

  const projects = data.projects.map((project) => {
    let projectImage = project.image;
    const badge = getBadge(project.title, project.url || '');
    const displayTitle = cleanTitle(project.title);
    return (
      <div key={project.title} className="ipad-app-tile">
        <a href={project.url} title={project.title} target="_blank" rel="noopener noreferrer" className="ipad-app-link">
          <div className="ipad-app-icon-wrapper">
            <span className={`portfolio-badge ${badge.type}`}>{badge.label}</span>
            <div className="ipad-app-icon-squircle">
              <img
                alt={project.title}
                src={projectImage}
                className="ipad-app-icon-img"
              />
              <div className="ipad-app-icon-sheen"></div>
            </div>
          </div>
          <div className="ipad-app-meta">
            <h5 className="ipad-app-title">{displayTitle}</h5>
            <p className="ipad-app-category">{project.category}</p>
            <div className="ipad-app-cta">
              GET <span className="cta-arrow">↗</span>
            </div>
          </div>
        </a>
      </div>
    );
  });

  return (
    <section id="portfolio" className="ipad-stage-section">
      <div className="row">
        <div className="twelve columns collapsed">
          <div className="ipad-header-group">
            <span className="ipad-os-pill">📱 iPad OS Showcase</span>
            <h3 className="section-title">Live Apps & Enterprise Showcase</h3>
            <p className="section-subtitle">Tap any app tile to launch the live product or App Store page</p>
          </div>

          <div className="ipad-screen-frame">
            <div className="ipad-screen-header">
              <div className="ipad-status-bar">
                <span className="ipad-time">{currentTime}</span>
                <span className="ipad-os-title">Guru's App Library</span>
                <span className="ipad-battery">100% 🔋</span>
              </div>
            </div>
            <div className="ipad-app-grid">
              {projects}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
